import { BookingProperty } from "../../../components/FacilityManager/Domain/Types/FloorPlan/BookingProperty.type";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

export const PROPERTY_TYPE_VALUES = ["workplace", "zone", "fleet"] as const;
export type PropertyTypeFilter = (typeof PROPERTY_TYPE_VALUES)[number];

export function useRemoteFetchBookingProperty(options?: {
  propertyType?: string[];
  enabled?: boolean;
}) {
  const propertyType = options?.propertyType?.filter(t =>
    PROPERTY_TYPE_VALUES.includes(t as PropertyTypeFilter)
  );
  const propertyTypeParam = propertyType?.length ? propertyType.join(",") : undefined;
  const queryKey = ["booking-properties", propertyTypeParam ?? "all"] as const;

  return useRemoteQuery<BookingProperty[]>({
    queryKey,
    url: `/booking-properties`,
    params: propertyTypeParam ? { propertyType: propertyTypeParam } : undefined,
    enabled: options?.enabled
  });
}
